import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text} from '@chakra-ui/react'

const LabelValue = ({label, value, valueColor, valueDotted}) => (
  <Flex justifyContent="space-between" alignItems="baseline" gap="sm">
    <Text
      fontSize="xs"
      color="mld.neutral.700"
      textTransform="uppercase"
      flexShrink={0}
    >
      {label}
    </Text>
    <Text
      fontSize="sm"
      fontWeight="medium"
      color={valueColor}
      textDecoration={valueDotted ? 'underline dotted' : undefined}
      textDecorationColor={valueDotted ? 'mld.neutral.500' : undefined}
      textUnderlineOffset="3px"
    >
      {value}
    </Text>
  </Flex>
)

LabelValue.defaultProps = {
  valueColor: undefined,
  valueDotted: false,
}

LabelValue.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  valueColor: PropTypes.string,
  valueDotted: PropTypes.bool,
}

export default LabelValue
